<template>
  <main-container
    :pageTitle="
      `${
        schoolName && schoolName !== 'null' ? schoolName : projectName
      } - ${heading}`
    "
  >
    <div slot="pageContent">
      <div>
        <stat-card
          statTitle="Total Students"
          :statNumber="totalUsersByFilters"
          color="primary"
        />
        <stat-card
          statTitle="Baselines Completed"
          :statNumber="totalAssessmentsCompletedAllThreads"
          color="primary"
        />
        <stat-card
          statTitle="Working on Catch Up"
          :statNumber="startedCatchup"
          color="primary"
        />
      </div>
      <div class="chart-area">
        <div>
          <section-btn
            name="assessments"
            :btn="0"
            :active="activeSection"
            v-on:buttonClicked="updateActiveSection"
          />
          <section-btn
            name="catch-up"
            :btn="1"
            :active="activeSection"
            v-on:buttonClicked="updateActiveSection"
          />
          <section-btn
            name="Improvements"
            :btn="3"
            :loading="!fetchedImprovements"
            :active="activeSection"
            v-on:buttonClicked="updateActiveSection"
          />
          <section-btn
            name="Engagements"
            :btn="4"
            :loading="!hasFetchedEngagements"
            :active="activeSection"
            v-on:buttonClicked="isInternalUpdateActiveSection"
          />
        </div>
        <div class="sections">
          <chart-section
            sectionTitle="Assessments"
            v-if="activeSection === 0 || activeSection === -1"
          >
            <div slot="chart">
              <chart-box
                chartName="Assessment Progress"
                :index="0"
                v-on:viewAllClicked="viewAllParameters"
                :students="progressArray"
                style="max-width: 100%; width: calc(100% - 24px)"
              >
                <div
                  v-if="pChart.data"
                  slot="chart"
                  style="width: 100%; background: #FAFAFA;"
                >
                  <bar-chart
                    style="padding: 10px 0; width: 90%; margin: auto; position: relative"
                    ref="assessment-progress"
                    chart-id="assessment-progress-chart"
                    :chart-data="pChart.data"
                    :extra-options="pChart.extraOptions"
                  >
                  </bar-chart>
                </div>
                <div slot="table" style="width: 100%;">
                  <learner-table
                    v-if="progressArray.length"
                    :index="0"
                    :users="progressArray"
                    class="small-table"
                    style="padding: 10px 0; width: 90%; margin: auto; position: relative; border-bottom: 2px solid #E0E0E0;box-shadow: inset 0 -20px 20px -20px rgba(50,50,50,0.2);"
                  />
                  <section v-else class="section">
                    <div class="has-text-grey has-text-centered">
                      <p>
                        <span class="icon is-large"
                          ><i class="mdi mdi-emoticon-sad mdi-48px"></i
                        ></span>
                      </p>
                      <p style="min-height:135px">No learners found.</p>
                    </div>
                  </section>
                </div>
              </chart-box>
              <chart-box
                chartName="Assessment Results"
                :index="1"
                :showResultsLink="false"
                v-on:viewAllClicked="viewAllParameters"
                :students="completedAssessmentResults"
                style="max-width: 100%; width: calc(100% - 24px)"
              >
                <div
                  v-if="rChart.data"
                  slot="chart"
                  style="width: 100%; background: #FAFAFA;"
                >
                  <bar-chart
                    style="padding: 10px 0; width: 90%; margin: auto"
                    ref="assessment-results"
                    chart-id="assessment-results-chart"
                    :chart-data="rChart.data"
                    :extra-options="rChart.extraOptions"
                  >
                  </bar-chart>
                </div>
                <div slot="table" style="width: 100%;">
                  <learner-table
                    v-if="completedAssessmentResults.length"
                    :index="1"
                    :users="completedAssessmentResults"
                    class="small-table"
                    style="padding: 10px 0; width: 90%; margin: auto; position: relative;border-bottom: 2px solid #E0E0E0;box-shadow: inset 0 -20px 20px -20px rgba(50,50,50,0.2);"
                  />
                  <section v-else class="section">
                    <div class="has-text-grey has-text-centered">
                      <p>
                        <span class="icon is-large"
                          ><i class="mdi mdi-emoticon-sad mdi-48px"></i
                        ></span>
                      </p>
                      <p style="min-height:135px">
                        No learners found with completed assessments.
                      </p>
                    </div>
                  </section>
                </div>
              </chart-box>
            </div>
          </chart-section>
          <chart-section
            sectionTitle="Catch-up"
            v-if="activeSection === 1 || activeSection === -1"
          >
            <div slot="chart">
              <chart-box
                :showLink="false"
                :index="2"
                chartName="Catch-up Progress"
                :students="completedAssessmentResults"
                style="max-width: 100%; width: calc(100% - 24px)"
              >
                <div
                  v-if="cpChart.data"
                  slot="chart"
                  style="width: 100%; background: #FAFAFA;"
                >
                  <bar-chart
                    style="padding: 10px 0; width: 90%; margin: auto; position: relative"
                    ref="catchup-progress"
                    chart-id="catchup-progress-chart"
                    :chart-data="cpChart.data"
                    :extra-options="cpChart.extraOptions"
                  >
                  </bar-chart>
                </div>
                <div slot="table" style="width: 100%;">
                  <learner-table
                    :index="2"
                    v-if="sortedCatchupData.length"
                    :users="sortedCatchupData"
                    tableType="catchup"
                    class="small-table"
                    style="padding: 10px 0; width: 90%; margin: auto; position: relative; border-bottom: 2px solid #E0E0E0;box-shadow: inset 0 -20px 20px -20px rgba(50,50,50,0.2);"
                  />
                  <section v-else class="section">
                    <div class="has-text-grey has-text-centered">
                      <p>
                        <span class="icon is-large"
                          ><i class="mdi mdi-emoticon-sad mdi-48px"></i
                        ></span>
                      </p>
                      <p>No learners found with catch-up data.</p>
                    </div>
                  </section>
                </div>
              </chart-box>
              <!-- <chart-box chartName="Catch-up Results"></chart-box> -->
            </div>
          </chart-section>
          <!-- <chart-section
            sectionTitle="Learning Behaviors"
            v-if="activeSection === 2 || activeSection === -1"
          >
            <div slot="chart">
              <chart-box chartName="Learning behaviors"></chart-box>
            </div>
          </chart-section> -->
          <chart-section
            sectionTitle="Improvements"
            v-if="
              fetchedImprovements &&
                (activeSection === 3 || activeSection === -1)
            "
          >
            <div slot="chart">
              <chart-box
                v-if="fetchedImprovements"
                chartName="Improvements"
                :showLink="false"
                :index="3"
                :students="sortedImprovementData"
                style="max-width: 100%; width: calc(100% - 24px)"
              >
                <div
                  v-if="impChart.data"
                  slot="chart"
                  style="width: 100%; background: #FAFAFA;"
                >
                  <bar-chart
                    v-if="fetchedImprovements"
                    style="padding: 10px 0; width: 90%; margin: auto; position: relative"
                    ref="improvements"
                    chart-id="improvements-chart"
                    :chart-data="impChart.data"
                    :extra-options="impChart.extraOptions"
                  >
                  </bar-chart>
                </div>
                <div slot="table" style="width: 100%;">
                  <learner-table
                    v-if="sortedImprovementData.length"
                    :index="3"
                    :users="sortedImprovementData"
                    tableType="improvements"
                    class="small-table"
                    style="padding: 10px 0; width: 90%; margin: auto; position: relative; border-bottom: 2px solid #E0E0E0;box-shadow: inset 0 -20px 20px -20px rgba(50,50,50,0.2);"
                  />
                  <section v-else class="section">
                    <div class="has-text-grey has-text-centered">
                      <p>
                        <span class="icon is-large"
                          ><i class="mdi mdi-emoticon-sad mdi-48px"></i
                        ></span>
                      </p>
                      <p>No learners found with improvements data.</p>
                    </div>
                  </section>
                </div>
              </chart-box>
              <!-- <chart-box chartName="Catch-up Results"></chart-box> -->
            </div>
          </chart-section>

          <engagements-window
            :learnersData="rawEngLearnerData"
            v-if="activeSection === 4 || activeSection === -1"
          >
          </engagements-window>
        </div>

        <learner-profile></learner-profile>

        <div :style="{ visibility: hideModal ? 'hidden' : '' }">
          <view-all :params="viewAllParams"></view-all>
        </div>

        <results-breakdown
          :studentsList="completedAssessmentResults"
        ></results-breakdown>
      </div>
    </div>
  </main-container>
</template>

<script>
import MainContainer from "@/modules/global/containers/MainContainer.vue";
import StatCardComponent from "@/modules/home/components/StatCardComponent.vue";
import SectionButtonComponent from "@/modules/global/components/SectionButtonComponent.vue";
import ChartSectionComponent from "@/modules/home/components/ChartSectionComponent.vue";
import ChartBoxComponent from "@/modules/home/components/ChartBoxComponent.vue";
import BarChart from "@/modules/global/lib/charts/BarChart.js";
import assessmentChartDataGeneratorMixin from "@/modules/global/mixins/assessmentChartDataGeneratorMixin.js";
import engagementChartDataGeneratorMixin from "@/modules/global/mixins/engagementChartDataGeneratorMixin.js";
import localizationMixin from "@/modules/global/mixins/localizationMixin.js";
import catchupChartData from "@/modules/global/mixins/catchupChartData.js";
import LearnerTable from "@/modules/global/components/TableComponent.vue";
import { mapState, mapGetters, mapMutations } from "vuex";
import LearnerProfileLayout from "@/modules/global/layouts/LearnerProfileLayout.vue";
import ViewAllLayout from "@/modules/global/layouts/ViewAllLayout.vue";
import ResultsBreakdownLayout from "@/modules/global/layouts/ResultsBreakdownLayout.vue";
import EngagementsWindow from "./components/EngagementsWindow.vue";
// import CSVDownload from "@/modules/global/components/VueXLSXDownloadComponent.vue";
export default {
  name: "home",
  data() {
    return {
      isLearnerModalActive: true,
      activeLearner: null,
      activeSection: 0,
      viewAllParams: null
    };
  },
  mixins: [
    localizationMixin,
    assessmentChartDataGeneratorMixin,
    engagementChartDataGeneratorMixin,
    catchupChartData
  ],
  components: {
    "main-container": MainContainer,
    "stat-card": StatCardComponent,
    "section-btn": SectionButtonComponent,
    "chart-section": ChartSectionComponent,
    "chart-box": ChartBoxComponent,
    "bar-chart": BarChart,
    "learner-table": LearnerTable,
    "learner-profile": LearnerProfileLayout,
    "view-all": ViewAllLayout,
    "results-breakdown": ResultsBreakdownLayout,
    "engagements-window": EngagementsWindow
  },
  computed: {
    ...mapState({
      activeFilterParams: state => state.globalStore.activeFilterParams,
      reflectiveData: state => state.globalStore.reflectiveData,
      active: state => state.globalStore.activeFilterParams,
      threadId: state => state.globalStore.activeFilterParams.threadId,
      assessmentType: state =>
        state.globalStore.activeFilterParams.assessmentType,
      projectName: state => state.globalStore.activeFilterParams.projectName,
      schoolName: state => state.globalStore.activeFilterParams.school,
      isInternal: state => state.globalStore.settings.isInternal
    }),
    ...mapGetters({
      userData: "globalStore/getFilteredList",
      fetchedImprovements: "globalStore/fetchedImprovements",
      hasFetchedEngagements: "newEngagementsStore/getRawEngagementsData"
    }),
    heading() {
      if (this.active.class) {
        return `Class ${this.active.class}`;
      } else if (this.active.isMatricAssessment) {
        return "Adult Diagnostics";
      }
      if (!this.active.grade) {
        return "All";
      }
      return ` ${this.contextualSpecificGradeAndLabel(this.active.grade)}`;
    },
    hideModal() {
      if (this.activeLearnerModal) {
        return true;
      }
      return false;
    },
    rawEngLearnerData() {
      return this.userData.map(obj => {
        const learner = {
          _id: obj._id,
          email: obj.email,
          grade: obj.grade,
          class: obj.class,
          school: obj.school,
          project: obj.project,
          lastName: obj.lastName,
          firstName: obj.firstName,
          createdAt: obj.createdAt,
          updatedAt: obj.updatedAt
        };

        return learner;
      });
    }
  },
  methods: {
    ...mapMutations({
      updateTime: "globalStore/updateTime",
      updateActiveLearnerButton: "globalStore/updateActiveButton"
    }),
    async isInternalUpdateActiveSection(payload) {
      return this.updateActiveSection(payload);
      // if (this.isInternal) return this.updateActiveSection(payload);
    },
    async updateActiveSection(payload) {
      this.activeSection = payload;
    },
    openLearnerProfile(val) {
      this.activeLearner = val;
      this.isLearnerModalActive = true;
    },
    closeLearnerProfile() {
      this.isLearnerModalActive = false;
    },
    viewAllParameters(payload) {
      this.viewAllParams = payload;
    }
  },
  watch: {
    activeSection: {
      handler: function(t, e) {
        if (t === 0) {
          this.$nextTick(() => {
            this.AllUsersResultsArrays();
            this.AllUserProgressArrays();
          });
        } else if (t === 1) {
          this.$nextTick(() => {
            this.stackedBarGraph(this.masteredConceptsPerUser);
          });
        } else if (t === 3) {
          this.$nextTick(() => {
            this.stackedImprovementBarGraph(this.improvementsPerUser);
          });
        } else if (t === 4) {
          this.$nextTick(() => {
            this.LearnerEngagement();
          });
        }
      }
    }
  },
  mounted() {
    // console.log("activeFilterParams", this.activeFilterParams);
    // console.log("User Data", this.userData);
    // console.log("Learner Data: ", this.rawEngLearnerData);
  }
};
</script>
